import dayjs from 'dayjs/esm';
import updateLocale from 'dayjs/plugin/updateLocale';
import duration from 'dayjs/esm/plugin/duration';
import isBetween from 'dayjs/esm/plugin/isBetween';
import isSameOrAfter from 'dayjs/esm/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/esm/plugin/isSameOrBefore';
import localeData from 'dayjs/esm/plugin/localeData';
import localizedFormat from 'dayjs/esm/plugin/localizedFormat';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import timezone from 'dayjs/esm/plugin/timezone';
import utc from 'dayjs/esm/plugin/utc';
import weekOfYear from 'dayjs/esm/plugin/weekOfYear';
import customParseFormat from 'dayjs/esm/plugin/customParseFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import advancedFormat from 'dayjs/esm/plugin/advancedFormat';

import 'dayjs/esm/locale/fr';
import 'dayjs/esm/locale/en';
import 'dayjs/esm/locale/de';
import 'dayjs/esm/locale/es';
import 'dayjs/esm/locale/it';
import 'dayjs/esm/locale/pl';
import 'dayjs/esm/locale/zh-cn';

dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);
dayjs.extend(quarterOfYear);
dayjs.extend(advancedFormat);

dayjs.updateLocale('en', { weekStart: 1 });

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$dayjs = dayjs;
  },
};

export { dayjs };
